/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Comment/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CommentAction from './CommentAction/index'
import CommentTextArea from './CommentTextArea/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Comment({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Comment"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Comment.Vertical"
  data-view-path={viewPath}
 style={{'--btlr-1-Z1Yk7NE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-2-Z1Yk7NE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-Z1Yk7NE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-4-Z1Yk7NE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-5-Z1Yk7NE': dtColorsNeutral300}}
 className={`views-block ${styles.Vertical}`}
>
<CommentTextArea
  viewPath={`${viewPath}/CommentTextArea`}
/>
<div
  data-testid="Comment.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-6-Z1Yk7NE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-7-Z1Yk7NE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-8-Z1Yk7NE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-9-Z1Yk7NE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btc-10-Z1Yk7NE': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
>
<CommentAction
  viewPath={`${viewPath}/CommentAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}